import * as fromDatatype from '../../../../models/datatype-library';

export class FinancialItemPricingListingDTO {
  // item hdr
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_name: fromDatatype.VarcharDatatypeInterface;
  item_hdr_code: fromDatatype.VarcharDatatypeInterface;
  item_hdr_uom: fromDatatype.VarcharDatatypeInterface;

  // item line
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  item_line_code: fromDatatype.VarcharDatatypeInterface;
  item_line_name: fromDatatype.VarcharDatatypeInterface;
  item_line_uom: fromDatatype.VarcharDatatypeInterface;

  // pricing scheme hdr
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_hdr_name: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_code: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_txn_type: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_level_value: fromDatatype.VarcharDatatypeInterface;

  // pricing scheme link
  pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_link_guid_hdr: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_link_guid_item_hdr: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_link_guid_item_line: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.VarcharDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.VarcharDatatypeInterface;
}